import React from 'react';
import colors from 'src/utils/colors';

const KeywordTag = ({ label, isEnhanced = false }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '6px 12px',
      backgroundColor: isEnhanced ? colors.greenTagOpaque : colors.blueTagOpaque,
      color: colors.darkBlue,
      borderRadius: '16px',
      fontSize: '14px',
      fontStyle: 'normal',
      height: '32px',
      boxSizing: 'border-box',
      fontWeight: 500
    }}
  >
    {label}
  </span>
);

export default KeywordTag;
